import { API_URL } from '../../Config/Config';
import { apiGet, apiPost, processResponse } from '../standardApi';
import Store from '../../Redux/Store';
import {
  addPipelineLoader,
  rmPipelineLoader
} from '../../Redux/Actions/authActions/authActions';

export async function apiLogin(emailOrMemberNumber, password) {
  const api = API_URL + '/Auth/Login';
  Store.dispatch(addPipelineLoader(api));
  try {
    const response = await fetch(api, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        accept: 'text/plain'
      },
      body: JSON.stringify({
        emailOrMemberNumber: emailOrMemberNumber,
        password: password
      })
    });
    Store.dispatch(rmPipelineLoader(api));
    return processResponse(response);
  } catch (e) {
    Store.dispatch(rmPipelineLoader(api));
    return;
  }
}
export async function apiRefreshToken(refreshToken) {
  const response = await fetch(API_URL + '/auth/refresh', {
    method: 'Get',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      accept: 'application/json',
      Authorization: 'Bearer ' + refreshToken
    }
  });
  return response.json();
}
export async function apiCheckMember(emailOrMemberNumber) {
  const response = await apiPost(
    '/Auth/CheckMember',
    JSON.stringify({
      emailOrMemberNumber: emailOrMemberNumber
    }),
    'text/plain'
  );
  return response;
}
export async function apiCheckEmail(emailOrMemberNumber) {
  const response = await apiPost(
    '/Auth/CheckEmail',
    JSON.stringify({
      emailOrMemberNumber: emailOrMemberNumber
    }),
    'text/plain'
  );
  return response;
}
export async function apiResetPassword(userId, password) {
  const response = await apiPost(
    `/Auth/ResetPassword?userId=${userId}`,
    JSON.stringify({
      password: password
    }),
    'text/plain'
  );
  return response;
}

export async function apiCreateAccount(memberId, password) {
  const response = await apiPost(
    `/Auth/CreateAccount?memberId=${memberId}`,
    JSON.stringify({
      password: password
    }),
    'text/plain'
  );
  return response;
}

export async function apiCheckLinkValidity(token) {
  const response = await apiGet(`/Auth/CheckLinkValidity?token=${token}`);
  return response;
}
